module.exports = __webpack_public_path__ + "img/Shakhtar-Donetsk.4306d403.png";